import React from "react";
import { View } from "react-native";
import { useNavigation } from "@react-navigation/core";
import CryptoListSelection from "../../components/CryptoListSelection";
import { FormattedMessage } from "react-intl";
import HeaderTabs from "../../components/HeaderTabs";
import GoBackButton from "../../components/GoBackButton";

const WithdrawCryptoSelection = () => {
  const navigation = useNavigation();

  function onCryptoSelected(crypto) {
    navigation.navigate({ name: "WithdrawCrypto", params: { crypto } });
  }

  return (
    <View>
      <HeaderTabs
        title={<FormattedMessage id="withdrawcryptoselection.sacarTitulo" />}
        subtitle={<FormattedMessage id="depositCrypyoSelection.emBreve" />}
      />
      <GoBackButton />

      <CryptoListSelection onItemPressed={onCryptoSelected} />
    </View>
  );
};

export default WithdrawCryptoSelection;
